import api from '@/plugins/axios';

export const GetContent = async (page: string) => {
    const { data } = await api.get(`/content`, { params: { page } })
    return data;
}

export const SaveContent = async (page: string, content: unknown): Promise<void> => {
    await api.post(`/content?page=${page}`, { content });
}